import { TERMS_VERSION } from '@iqrapath/shared'
import { ChevronLeft } from 'lucide-react'
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import { LEGAL, LEGAL_REVIEWED, isLegalSlug } from './legal.ts'

export function LegalPage() {
  const { doc } = useParams()
  const navigate = useNavigate()
  if (!isLegalSlug(doc)) return <Navigate to="/" replace />
  const d = LEGAL[doc]
  return (
    <article className="legal">
      <button type="button" className="back" onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}>
        <ChevronLeft size={18} aria-hidden="true" /> Kembali
      </button>
      {!LEGAL_REVIEWED && (
        <p className="draft-banner" role="note">Draf, belum ditinjau secara hukum. Jangan dipublikasikan sebelum ditinjau.</p>
      )}
      <h1>{d.title}</h1>
      <p className="muted">Versi {TERMS_VERSION}</p>
      {d.sections.map((s) => (
        <section key={s.h}>
          <h2>{s.h}</h2>
          {s.p?.map((t) => <p key={t}>{t}</p>)}
          {s.ul && <ul>{s.ul.map((t) => <li key={t}>{t}</li>)}</ul>}
        </section>
      ))}
      <p className="muted" style={{ marginTop: 28 }}>
        <Link to="/legal/syarat">Syarat</Link> · <Link to="/legal/privasi">Privasi</Link> · <Link to="/legal/disclaimer">Disclaimer</Link>
      </p>
    </article>
  )
}
